'use client'

import { Children, PropsWithChildren } from 'react'
import { motion } from 'motion/react'
import { usePrefersReducedMotion } from './usePrefersReducedMotion'
import { MORPH_TRANSITION } from './constants'

type MorphDialogBodyProps = {
  className?: string
}

export function MorphDialogBody({
  className,
  children,
}: PropsWithChildren<MorphDialogBodyProps>) {
  const prefersReducedMotion = usePrefersReducedMotion()

  if (prefersReducedMotion) {
    return <div className={className}>{children}</div>
  }

  const items = Children.toArray(children)

  return (
    <div className={className}>
      {items.map((child, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, filter: 'blur(8px)' }}
          animate={{ opacity: 1, filter: 'blur(0px)' }}
          exit={{ opacity: 0, filter: 'blur(8px)' }}
          transition={{
            duration: MORPH_TRANSITION.content.itemDuration,
            delay:
              MORPH_TRANSITION.content.initialDelay +
              index * MORPH_TRANSITION.content.stagger,
            ease: 'easeOut',
          }}
        >
          {child}
        </motion.div>
      ))}
    </div>
  )
}
